import appConfig from 'app.config'

const CHAIN = parseInt(process.env.CHAIN, 10)

const isStaging =
  location.origin.indexOf('staging') > -1 ||
  location.origin.indexOf('ngrok') > -1 ||
  location.origin.indexOf('localhost') > -1

/**
 * The core application constants. Includes `process.env` config,
 * which is supplied by the `webpack.EnvironmentPlugin`
 * (see `bin/config/webpack.plugins`)
 */
export default {
  // Apply the app config
  ...appConfig,
  ...appConfig.CONFIG[CHAIN === 137 ? 'MAINNET' : 'MAINNET'],

  API_URL: window.metropolisInfo?.api || 'https://api.metropolisx.io',
  API_V2_URL: window.metropolisInfo?.apiV2 || 'https://api2.metropolisx.io',

  INDEX_DB_DATABASE_NAME: 'metropolisXDatabase',

  // Sentry DSN (where to send events)
  SENTRY_DSN: isStaging
    ? 'https://6ae9f7befd640e3f6068a9a1b045ee03@o4506534803931136.ingest.sentry.io/4506734750203904'
    : 'https://4d8628d513bd519dbed57adeeb0ac119@o4506534803931136.ingest.sentry.io/4506734665793536',

  // The mode
  MODE: Number(process.env.MODE) || 0,

  // Is dev mode
  IS_DEV: process.env.NODE_ENV === 'development',

  // Is beta mode
  IS_BETA: process.env.IS_BETA === 'true',

  // Whether can edit
  CAN_EDIT: process.env.EDIT === 'true',

  // Whether marketplace is enabled
  IS_MARKETPLACE_ENABLED: process.env.MARKETPLACE === 'true',

  // Whether non-passport sign ups are allowed
  IS_SIGN_UP_ENABLED: process.env.SIGNUP === 'true',

  // Whether paper wallets are enabled
  IS_PAPER_ENABLED: process.env.PAPER === 'true',

  // Whether thirdweb is enabled
  IS_THIRDWEB_ENABLED: process.env.THIRDWEB === 'true',

  // Whether credit card is enabled
  IS_CREDIT_CARD_ENABLED: process.env.CREDIT_CARD === 'true',

  // Whether free minting is enabled for paper accounts
  IS_PAPER_CREATE_AVATAR_FREE_MINT_ENABLED: process.env.FREE_MINT === 'true',
  IS_PAPER_EDIT_AVATAR_FREE_MINT_ENABLED: process.env.FREE_MINT === 'true',

  // Google Tag Manager ID
  GTM_ID: window.metropolisInfo?.gtmId,

  // The chain
  CHAIN,

  // Matic address
  MATIC_ADDRESS: process.env.MATIC_ADDRESS,

  // Thirdweb client id
  THIRDWEB_CLIENT_ID: process.env.THIRDWEB_CLIENT_ID,

  // Asset path configurations
  PATH_ASSETS: process.env.ASSETS,
  PATH_DATA: window.metropolisInfo?.pathData,

  // Image kit
  PATH_CDN: process.env.CDN,

  // App behaviors
  CACHE_BUST_VERSION: window.metropolisInfo?.cacheVersion,

  // General
  // The large screen breakpoint
  BREAKPOINT_LARGE_SCREEN: 980,

  // Breakpoint configurations (should match CSS breakpoints)
  BREAKPOINTS: {
    xs: 576,
    sm: 768,
    md: 980,
    lg: 1200,
    xl: 1400,
    xxl: 1600,
    xxxl: 2000
  },

  COLORS: {
    canvas: '#221f1c'
  }
}
